import { useEffect, useRef } from 'react';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { expired, success } from '../assets/images';
import Container from '../components/layouts/Container/Container';
import PageWrapper from '../components/layouts/PageWrapper/PageWrapper';
import { authPages } from '../config/pages.config';
import { useAuth } from '../context/authContext';
import { verifyEmail } from '../services/apiService';

const VerifyEmailPage = () => {
	const { token } = useParams<{ token: string }>();
	const { response, error, loading, call } = verifyEmail();
	const { onLogout} = useAuth();
	const hasCalled = useRef(false);
	useEffect(() => {
		if (token && !hasCalled.current) {
			hasCalled.current = true;
			call(token).subscribe({
				error: (e: any) => {
					if (e?.status=== 409) {
						onLogout(e?.status);
					}
					toast.error(e?.data?.msg || e.message);
				}
			});
		}
	}, [token]);

	return (
		<PageWrapper isProtectedRoute={false} name='Verfiy Email'>
			<Container className='flex h-full items-center justify-center'>
				<div className='grid grid-cols-12 gap-4'>
					<div className='col-span-12 mb-16 flex flex-wrap justify-center gap-4'>
						<div className='flex basis-full justify-center'>
							<span className='text-5xl font-semibold'>
								{ response?.msg ? 'Success' : error?.data?.msg ? 'Error' : 'Loading...' }
							</span>
						</div>
						<div className='flex basis-full justify-center'>
							<span className='text-zinc-500'>
								{ response?.msg ?? error?.data?.msg ?? 'Verifying your email, Please wait...' }
							</span>
						</div>
					</div>
					<div className='col-span-3' />
					<div className='col-span-6 flex justify-center'>
						{ response?.msg ? <img src={success as string} alt='' className='w-full h-auto' /> : <img src={expired as string} alt='' className='w-full h-auto' /> }
					</div>
					<div className='col-span-12 flex justify-center'>
						<span className='flex gap-2 text-sm'>
							<span className='text-zinc-400 dark:text-zinc-600'>
								Already verified ?
							</span>
							<Link to={`${authPages.loginPage.to}`} className='hover:text-inherit'>
								Sign in
							</Link>
						</span>
					</div>
				</div>
			</Container>
		</PageWrapper>
	);
};

export const RedirectToNotFound = () => {
	const location = useLocation(); // Access the current location
	const currentPath = location.pathname + location.search; // Get the full path
	return (
		<Navigate
			to={`${authPages.notFoundPage.to}?page=${encodeURIComponent(currentPath)}`}
			replace
		/>
	);
};

export default VerifyEmailPage;
